import React from 'react'
import PropTypes from 'prop-types'

import styles from './Slice.module.scss'

const precision = 1
const factor = Math.pow(10, precision)
const round = n => Math.trunc(n * factor) / factor
const radius = 100
const translation = 15

const defaultProps = {
  start: 0,
  value: 0,
  className: styles.slice
}

const coords = percent => {
  const v = 2 * Math.PI * percent
  return [Math.cos(v), Math.sin(v)].map(v => round(v * radius))
}

const dStart = v => {
  const [x, y] = coords(v)
  return `M ${x} ${y}`
}

const dArc = (v1, v2) => {
  const largeArc = v2 > 0.5 ? 1 : 0
  const [x, y] = coords(v1 + v2)
  return `A ${radius} ${radius} 0 ${largeArc} 1 ${x} ${y}`
}

const getOffset = (v1, v2) => {
  const [x, y] = coords(v1 / 2 + v2)
  const xOff = -1 * round(x / translation)
  const yOff = round(y / translation)
  return `translate(${xOff}px, ${yOff}px)`
}

const dLine = 'L 0 0'

const PieChartSlice = ({ start, value, offset, ...restProps }) => {
  const additional = {}

  if (offset) {
    additional.style = {
      transform: getOffset(start, value)
    }
  }

  if (!value) {
    return null
  }

  return (
    <path
      {...restProps}
      {...additional}
      d={`${dStart(start)} ${dArc(start, value)} ${dLine}`}
    />
  )
}

PieChartSlice.defaultProps = defaultProps
PieChartSlice.propTypes = {
  start: PropTypes.number,
  value: PropTypes.number.isRequired,
  offset: PropTypes.bool,
  className: PropTypes.string
}

export default PieChartSlice
